// extracted by mini-css-extract-plugin
export default {"autocomplete-dropdown":"Autocomplete_root_autocomplete-dropdown__9mhfL","marg_top":"Autocomplete_root_marg_top__G5ia-"};